// {{-- ----------------------------------------------------------------- --}}
// {{-- Scripts to handle sessions - keeping them alive and killing them  --}}
// {{-- ----------------------------------------------------------------- --}}
// {{-- I. Overall session control:                                                                                                         --}}
// {{-- 1. All session control is browser-specific. We are looking at ONE browser instance.                                                 --}}
// {{-- 2. If the user opens an incognito tab, that is treated as a separate browser instance.                                              --}}
// {{-- II. When do we want to make sure sessions are closed?                                                                               --}}
// {{-- 1. Log outs: When users log out in one tab, we want all tabs to immediately (or nearly immediately) be logged out and go home.      --}}
// {{-- 2. Timeouts: Timeouts are also browser-specific; if users are active in one tab, they're active on the browser;                     --}} 
// {{--    so when user sessions time out on the browser, we log them out and we're back to the log out case.                               --}}
// {{-- 3. Disconnect: If users lose connection/browser/whatever, they must time out in a few seconds, and we're back to the time out case. --}}
// {{-- 4. Closing tabs: specific tabs (like editor instances) may handle their own tab-specific session closes.                            --}}
// {{--     (e.g. the editorsessions table) when their tabs are closed.                                                                     --}}
// {{--     Otherwise, we will close them when the user logs out (or is logged out) and the browser session is closed.                      --}}
// {{-- III. Important features:                                                                                                            --}}
// {{-- 1. If a user walks away from a screen, we want to show a warning message 60 seconds before ending the session.                      --}}
// {{-- 2. If the warning message receives no interaction, we want to end the session and redirect the user's screen to home.               --}}
// {{-- 3. In implementing a heartbeat system, we do not want the overhead of loading the entire Laravel app at each heartbeat.             --}}
// {{-- 4. Multiple tabs - if the user is logged out / disconnected in one tab, all tabs must immediately reflect that.                     --}}
// {{-- ----------------------------------------------------------------- --}}

var sessionUserIdleCycles       = 1;
var sessionToken                = isThere(glb_session_token) ? glb_session_token : '';
var sessionLifetime             = isThere(glb_session_lifetime) ? glb_session_lifetime : 30;
var sessionHalfLifeTimeInMsec   = (sessionLifetime / 2) * 60 * 1000;
var sessionHeartbeat            = isThere(glb_session_heartbeat) ? glb_session_heartbeat : 10;
var sessionChannelName          = 'singlecast.' + $('#user_id').val();
var sessionPrivateChannelName   = 'private-' + sessionChannelName;
var sc_countdown_interval;
var sc_sendHb_interval;
var sc_hb_count                 = 0;
var sc_hb_dead_count            = 10;
var sc_ping_count               = 0;
var sc_countdown_status         = 'off';            // 'off', 'on', or 'expired'
var sc_hbTimeout                = 3000;
var sc_pingTimeout              = 10000;
var sc_lastUserActiveCheck      = Date.now();

var verbose = false;

// Function to re-initialize the local sessionToken from the global glb_session_token
// This should be called after the navbar (and thus glb_session_token) is refreshed.
window.reinitializeSessionToken = function() {
    sessionToken = isThere(glb_session_token) ? glb_session_token : '';
    if (verbose) console.log(new Date().toLocaleTimeString(), 'Session token reinitialized:', sessionToken);
};

//{{-- Immediately grab mousemove and keydown events to monitor user activity --}}
document.addEventListener('mousemove', checkUserActivity, true);
document.addEventListener('keydown', checkUserActivity, true);

$(function(){    
    //{{-- Start listening for SSE messages --}}
    listenForPusher(sessionPrivateChannelName, sc_handleSSE, ['sessionstartcountdown', 'sessionkill']);

    //{{-- Start listening for the 'logout_reason' variable to appear in the session storage --}}
    window.addEventListener('storage', function(evt) {
        handleLocalStorageEvent(evt.key, evt.newValue);
    });

    //{{-- Start listening for the user moving to a different tab (or returning) --}}
    //{{-- ... so we can adjust sc_pingTimeout to account for the browser throttling our server communications --}}
    document.addEventListener("visibilitychange", function() {
        if (document.visibilityState === "visible") {
            //{{-- User is back --}}
            sc_pingTimeout = 10000;     // 10 seconds
            sc_hbTimeout = 3000         // 3 seconds
            sc_hb_dead_count = 10;
        } else if (document.visibilityState === "hidden") {
            //{{-- User went away --}}
            sc_pingTimeout = 120000;    // 120 seconds
            sc_hbTimeout   = 70000      // 70 seconds
            sc_hb_dead_count = 20;
        }
    });
      
    //{{-- If user closes countdown modal, send local storage variable so all tabs can cancel their countdowns --}}
    $('#sessionCheckModal').safeOn('hidden.bs.modal', function(evt) {
        if (sc_countdown_status === 'on') {
            sc_triggerLocalStorageEvent('countdown', 'cancel');
        }
    });

    // {{-- Send heartbeat every 10 seconds or so--}}
    sc_sendHeartbeat();
    sc_sendHb_interval = setInterval(sc_sendHeartbeat, sessionHeartbeat * 1000);

});

//{{-- keepAlive is used by JMS to keep the jobs grid from logging out. Just call keepAlive() on the page's initialization. --}}
window.keepAlive = function() {
    sc_keepAlive_interval = setInterval(refreshCSRFToken, sessionHalfLifeTimeInMsec);
}

//{{-- Check if user is active and reset the countdown every half lifetime, if they are --}}
function checkUserActivity(evt) {
    if ((Date.now() - sc_lastUserActiveCheck) >= sessionHalfLifeTimeInMsec) {
        if (verbose) console.log('User is active after half of session lifetime, or ' + sessionHalfLifeTimeInMsec + ' msec.');
        sc_triggerLocalStorageEvent('countdown', 'cancel');
    }
}

//{{-- This is fired every time something changes in localStorage --}}
//{{-- Note that logout_reason == disconnect must NOT call sc_logout --}}
function handleLocalStorageEvent(key, value) {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'Storage event fired:', key, value);
    if (key === 'logout_reason') {
        if (isThere(value)) {
            if (value == 'disconnect') {
                $('#disconnectModal').modal('show');
            } else {
                sc_logout(value);
            }
        }
    } else if (key === 'countdown') {
        if (isThere(value)) {
            if (value == 'cancel') {
                cancelCountdown();
            }
        }
    }
}

//{{-- If user closes modal, send heartbeat and session nudge - this will restart the session monitoring --}}
//{{-- Note that sc_countdown_status = 'off' must come before modal('hide') to avoid an infinite loop among the various tabs. --}}
function cancelCountdown() {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'Cancelling countdown.');
    sc_lastUserActiveCheck = Date.now();
    sc_sendHeartbeat();
    sc_serverPing();
    localStorage.removeItem('logout_reason');
    sc_countdown_status = 'off';
    clearInterval(sc_countdown_interval);
    $('#sessionCheckModal').modal('hide');
    setTimeout(() => {
        localStorage.removeItem('countdown');
    }, "100"); 
}

function sc_sendHeartbeat() {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'sending heartbeat');
    if ($("#user_id").val() > 0) {  
        let param = { sessionToken: sessionToken };
        //{{-- Remember that sessionheartbeat.php is NOT part of Laravel --}}
        //{{-- We use sc_hbTimeout and sc_pingTimeout to circumvent connection errors caused by browser throttling --}}
        $.post({
            url: '/sessionheartbeat.php',
            data: param,
            timeout: sc_hbTimeout,
            success: function(data) {
                //{{-- If we get a response, it should be 'true'; if not, we try a full serverPing --}}
                if (verbose) console.log(new Date().toLocaleTimeString(), 'received heartbeat: ', data);
                if (data == 'true') {
                    sc_hb_count = 0;
                    sc_ping_count = 0;
                    //{{-- If we have a live connection, we can hide the disconnect modal --}}
                    $('#disconnectModal').modal('hide');
                } else {
                    sc_hb_count ++;
                    if (sc_countdown_status == 'off' && sc_hb_count >= sc_hb_dead_count) {
                        sc_serverPing();
                    }
                }
            },
            error: function(xhr, status, error) {
                //{{-- If we don't get a response,  we try a full serverPing --}}
                if (verbose) console.log(new Date().toLocaleTimeString(), 'heartbeat fail: ', status, error);
                sc_hb_count ++;
                if (sc_countdown_status !== 'on' && sc_hb_count >= sc_hb_dead_count) {
                    sc_serverPing();
                }
            }
        });
    }
}

//{{-- Pinging the server resets last_active... --}}
function sc_serverPing() {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'pinging server');
    refreshCSRFToken();
    sc_ping_count ++;
    $.post({
        url: sc_route_serverPing,
        data: null,
        timeout: sc_pingTimeout,
        success: function(data) {
            //{{-- If we get a response, it is Auth::check() result --}}
            if (verbose) console.log(new Date().toLocaleTimeString(), 'serverPing returned:' + data);
            if (data == '1') {
                if ($('#disconnectModal').is(':visible')) {
                    $('#disconnectModal').modal('hide');
                    sc_ping_count = 0;
                }
            } else if (sc_countdown_status == 'off') {
                sc_sessionKill('server');
            }
        },
        error: function(xhr, status, error) {
            if (sc_ping_count > sc_hb_dead_count) {
                //{{-- If we don't get a response, the session is truly dead --}}
                if (verbose) console.log(new Date().toLocaleTimeString(), 'serverPing failed: ', status, error);
                if (! $('#disconnectModal').is(':visible')) {
                    sc_sessionKill('disconnect');
                }
            }
        }
    });
}

//{{-- This will kill the local session. --}}
//{{-- @param killReason - one of 'disconnect', 'server', 'timeout' --}}
function sc_sessionKill(killReason) {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'entered sessionKill');

    //{{-- Stop everything --}}
    clearIntervalsAndStorage();

    //{{-- Set localStorage and trigger the storage event; --}}
    sc_triggerLocalStorageEvent('logout_reason', killReason);
  
}

//{{-- Stop on-going stuff and clear local storage (note we never query local storage, we're only interested in its change event) --}}
function clearIntervalsAndStorage() {
    clearInterval(sc_countdown_interval);
    // clearInterval(sc_sendHb_interval); // DON'T, WE NEED HB TO IDENTIFY A POSSIBLE DISCONNECT IF SOMETHING WENT WRONG AT THE END OF COUNTDOWN
    localStorage.clear();
}

//{{-- Set localStorage and trigger the storage event, which will call sc_logout or handle the disconnect or countdown cancel. --}}
//{{-- Remember, the storage event will be processed by all open tabs (automatically for all, except the issuing one, which is why we explicitly call it here) --}}
window.sc_triggerLocalStorageEvent = function(varType, reason) {
    localStorage.setItem(varType, reason);
    handleLocalStorageEvent(varType, reason);
}

//{{-- The app's main logout function. --}}
window.sc_logout = function(reason) {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'sc_logout started; reason:', reason);
    if (reason == 'disconnect') {
        sc_triggerLocalStorageEvent('logout_reason', 'disconnect');
    } else {
        //{{-- Stop everything --}}
        clearIntervalsAndStorage();

        //{{-- Log out--}}
        const csrf = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            url: sc_route_logout,
            type: 'POST',
            data: {'logout_reason' : reason},
            success: function(data) {
                if (verbose) console.log(new Date().toLocaleTimeString(), 'logout success: ', data);
                // Note that the session environment set in the server response gets passed along to the new request here.
                window.location.replace(data.redirect_url);
            },
            error: function(xhr, status, error) {
                if (verbose) console.log(new Date().toLocaleTimeString(), 'logout error: ', xhr, status, error);
                window.location.replace(sc_route_home);
            }
        });
    }
}

// The on-screen countdown to logout
// @param seconds is received from the server
// We calculate and use deadline because the countdown may stop when the user navigates away
function sc_countdown(seconds) {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'entered countdown:');
    sc_countdown_status = 'on';
    let deadline =  Math.floor( Date.now() / 1000 ) + seconds;
    let modalMsg = sc_txtLoggingOutInX + seconds + " " + sc_txtSecondsLower + ".<br>" + sc_txtToRemainLoggedIn;
    $('#sessionCheckMsg').html('<span>' + modalMsg +'</span>');
    $("#sessionCheckModal").modal('show');
    let remainingSeconds = seconds - 1;
    sc_countdown_interval = setInterval(() => {
        if (sc_countdown_status == 'on') {
            let modalMsg = sc_txtLoggingOutInX + remainingSeconds + " " + sc_txtSecondsLower + ".<br>" + sc_txtToRemainLoggedIn;
            $('#sessionCheckMsg').html('<span>' + modalMsg +'</span>');
            let now_sec = Math.floor( Date.now() / 1000 );
            remainingSeconds = deadline - now_sec;
            if (verbose) console.log(new Date().toLocaleTimeString(), remainingSeconds + ' seconds \n');
            if (remainingSeconds <= 0) {
                if (verbose) console.log(new Date().toLocaleTimeString(), 'Countdown expired, calling sessionKill. \n');
                sc_countdown_status = 'expired';
                clearInterval(sc_countdown_interval);
                sc_sessionKill('timeout');
            }            
        } else {
            clearInterval(sc_countdown_interval);
        }

    }, 1000);
}

function sc_handleSSE(data) {
    if (verbose) console.log(new Date().toLocaleTimeString(), 'sc_handleSSE');
    if (data.hasOwnProperty('message') && isThere(data.message.type)) {
        if (data.message.session_id == sessionToken) {
            if (verbose) console.log(new Date().toLocaleTimeString(), 'received SSE:', data.message.type);
            if (data.message.type === 'sessionstartcountdown') {
                if (verbose) console.log(new Date().toLocaleTimeString(), "data.message.type === 'sessionstartcountdown'");
                if (sc_countdown_status == 'off') {
                    sc_countdown(data.message.seconds);
                }
            } else if (data.message.type === 'sessionkill') {
                if (verbose) console.log(new Date().toLocaleTimeString(), "data.message.type === 'sessionkill'");
                if (sc_countdown_status == 'off') {
                    sc_sessionKill('server');
                }
            }    
        }
    }
}